import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UtilsNpsService } from '../utils.service';
import { ClientNpsMessageService } from 'src/app/shared/services/API/nps/client-nps-message.service';
import { NpsMessageResponse } from 'src/app/shared/services/responses/nps/nps-message.reponse';
import { CustomQuestionTypeEnum } from 'src/app/shared/enum/nps/custom-question-type.enum';
import { ListCustomQuestionAnswerRequest } from 'src/app/shared/services/requests/nps/list-custom-question-answer.request';
import { CustomQuestionAnswer } from 'src/app/shared/services/models/nps/custom-question-answer.model';

@Component({
  selector: 'app-custom-questions-page',
  templateUrl: './custom-questions-page.component.html',
  styleUrls: ['./custom-questions-page.component.css']
})
export class CustomQuestionsPageComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private alertService: AlertService,
    public router: Router,
    private utilsNpsService: UtilsNpsService,
    private clientNpsMessageService: ClientNpsMessageService,
  ) { }

  public customQuestionTypeEnum: typeof CustomQuestionTypeEnum = CustomQuestionTypeEnum;

  public isLoading: boolean = false;

  public npsModel: FormGroup;
  public npsMessageResponse: NpsMessageResponse;

  public arrayIndexNps = new Array(11);

  public colorCode: string = "";

  ngOnInit(): void {
    this.npsMessageResponse = this.utilsNpsService.getNpsMessageResponse();

    if (!this.npsMessageResponse.npsMessage || this.npsMessageResponse.listCustomQuestion.length <= 0)
      this.router.navigate([`nps/${this.npsMessageResponse.npsMessage.guid}`]);

    if (this.npsMessageResponse.npsScreenConfig.useColor) {
      this.colorCode = this.npsMessageResponse.npsScreenConfig.colorCode;
      document.documentElement.style.setProperty('--colorCodeNps', this.colorCode);
    }

    this.npsModel = this.formBuilder.group({
      customQuestions: this.formBuilder.array([]),
    });

    this.createForm();
  }

  get formArrayCustomQuestions() {
    return (this.npsModel.controls['customQuestions'] as FormArray);
  }

  createForm() {
    console.log("listCustomQuestion: ", this.npsMessageResponse.listCustomQuestion)
    this.npsMessageResponse.listCustomQuestion.forEach(question => {
      this.formArrayCustomQuestions.push(this.formBuilder.group({
        idCustomQuestion: [question.idCustomQuestion],
        customQuestion: [question.customQuestion],
        idCustomQuestionType: [question.idCustomQuestionType],
        answer: [''],
      }))
    });
    console.log("formArrayCustomQuestions: ", this.formArrayCustomQuestions)

  }

  saveNote() {
    if (this.isLoading)
      return;

    this.isLoading = true;

    let customQuestionsAnswerRequest = new ListCustomQuestionAnswerRequest();
    this.npsModel.get('customQuestions').getRawValue().forEach((x) => {
      if(x.answer === null || x.answer === undefined || x.answer === '')
        return;
      var customQuestionsAnswer = new CustomQuestionAnswer();
      customQuestionsAnswer.idCustomQuestionAnswer = 0;
      customQuestionsAnswer.idCustomQuestion = (x.idCustomQuestion != '') ? x.idCustomQuestion : 0;
      customQuestionsAnswer.answer = x.answer.toString();

      customQuestionsAnswerRequest.listCustomQuestionAnswer.push(customQuestionsAnswer);
    });

    if(customQuestionsAnswerRequest.listCustomQuestionAnswer.length == 0) {
      this.isLoading = false;
      this.router.navigate([`nps/end-nps/${this.npsMessageResponse.npsMessage.guid}`]);
      return;
    }

    this.clientNpsMessageService.saveAnswers(customQuestionsAnswerRequest).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.alertService.show('Sucesso', "Informações salvas com sucesso", AlertType.success);
        this.isLoading = false;
        this.router.navigate([`nps/end-nps/${this.npsMessageResponse.npsMessage.guid}`]);
      },
      error: (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }
}